import { render, staticRenderFns } from "./Consolidado.vue?vue&type=template&id=6054b6dc"
import script from "./Consolidado.vue?vue&type=script&lang=js"
export * from "./Consolidado.vue?vue&type=script&lang=js"
import style0 from "./Consolidado.vue?vue&type=style&index=0&id=6054b6dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports